<template>
  <div id="app">
    <Nav />
    <router-view/>
  </div>
</template>
<script>
  import Nav from './components/Nav'
  export default {
    components: { Nav }
  }
</script>
<style lang="less">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  body, ul {
    margin: 0;
    padding: 0;
  }
</style>
